import {
  SSR_CHOICE_PROTECTION_PARAMETER_TEMPLATES,
  type UserPlan,
  type Workbench,
} from '@minglun/domain';

export function createBrowserUserPlan(workbench: Workbench): UserPlan {
  const algorithm = workbench.defaults.solverAlgorithms.find((item) => item.isEnabled) ?? workbench.defaults.solverAlgorithms[0];
  if (!algorithm) throw new Error('资料库没有可用的求解器配置。');
  const createdAt = new Date().toISOString();
  const parameters = [
    ...algorithm.parameters.filter((parameter) => !parameter.key.startsWith('ssr_') && parameter.key !== 'time_limit_seconds' && parameter.key !== 'threads'),
    ...SSR_CHOICE_PROTECTION_PARAMETER_TEMPLATES,
  ];
  const baseAttributes = structuredClone(workbench.defaults.userBaseAttributeTemplate.values);
  const objectives = workbench.optimizationMetrics.map((metric) => ({ metricId: metric.id, weight: metric.defaultWeight, isEnabled: metric.defaultWeight > 0 }));
  const inventory = workbench.characters.map((character) => ({ characterId: character.id, wheelCount: 0, backpackFragmentCount: 0, itemFragmentCount: 0, ignoreFragments: false }));
  const solver = {
    algorithmId: algorithm.id,
    includeDestinyWheel: true,
    ignoredFragmentGroups: [],
    ssrWheelChoices: 0,
    ssrChoiceBalanceEnabled: false,
    preferFewerWheels: true,
    fragmentAnalysisEnabled: false,
    parameters: parameters.map((parameter) => ({ key: parameter.key, value: parameter.defaultValue })),
  };
  const lastResult = { status: 'not_run' as const, algorithmId: algorithm.id, startedAt: '', completedAt: '', elapsedMilliseconds: 0, isProvenOptimal: false, fateWheels: [], finalAttributes: [] };
  return {
    schemaVersion: '4.2', id: `user-plan.${crypto.randomUUID()}`, name: '我的方案', workbenchVersion: workbench.version, updatedAt: createdAt,
    baseAttributes, baseAttributePresets: [], objectives, objectivePresets: [], inventory, solver, lastResult, solverHistory: [],
    activeStudyId: 'study.default',
    studies: [{ id: 'study.default', name: '默认方案', description: '从默认配置创建', createdAt, updatedAt: createdAt, baseAttributes: structuredClone(baseAttributes), objectives: structuredClone(objectives), inventory: structuredClone(inventory), solver: structuredClone(solver), lastResult: structuredClone(lastResult) }],
  };
}
